<template>
  <div class="moreGift">
    <!-- 导航栏 -->
    <van-nav-bar :title="title" :fixed="true" :placeholder="true" left-arrow @click-left="onBack">
      <template #left>
        <van-icon name="arrow-left" size=".7rem" color="#FF9D11" />
      </template>
    </van-nav-bar>
    <!-- 内容 -->
    <div class="moreGift-wrapper">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="gift-block" v-for="(item,index) in list" :key="index">
          <div class="game-cont" @click="gameDateil('gamedetails',{gameid: item.gid})">
            <div class="game-icon-des">
              <div class="i-game">
                <img v-lazy="item.icon_url" />
              </div>
              <div class="game-des">
                <div class="game-name-size">
                  <p>{{item.game_name}}</p>
                  <p>{{item.title}}</p>
                  <p>剩余:{{item.keep_num}}</p>
                </div>
              </div>
            </div>
            <div class="game-down">
              <a v-if="item.pid!=100" @click.stop="downGame(item.down_url,item.pid,item.gid)">下载</a>
              <a v-else @click.stop="downGame(item.down_url,item.pid,item.gid)">开玩</a>
            </div>
          </div>
          <div class="gift-cont">
            <router-link
              tag="div"
              :to="{name:'giftDetails',query:{id:item.gift_id}}"
              class="gift-des"
            >
              <p class="title">{{item.sub_title}}</p>
              <p class="cont">{{item.summary}}</p>
            </router-link>
            <span class="get" @click="getCode(item.gift_id)" v-if="item.gift_code==''">领取</span>
            <span class="getted" v-else>已领取</span>
          </div>
        </div>
      </van-list>
    </div>
    <!-- Dialog 弹出框组件 -->
    <van-overlay :show="show" />
    <div class="dialog" v-show="show" title="领取成功" width="70%">
      <p class="g-title">领取成功</p>
      <p class="g-code">
        <span>礼包码</span>:
        <span class="code">{{this.code}}</span>
      </p>
      <p class="confirm" @click="copyCode">
        <span>复制</span>
      </p>
    </div>
  </div>
</template>

<script>
import { contTools,lyTool } from "@/mixins/contMixins";
import wapApiFun from "@/servers/wap-module/apiFun";
import comTools from "@/assets/js/until";
export default {
  name: "moreGift",
  mixins: [contTools,lyTool],
  data() {
    return {
      list: [],
      page: 1,
      title: "",
      loading: false,
      finished: false,
      code: "", // 礼包码
      show: false // 隐藏弹出弹框
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {
    onLoad() {
      // 异步更新数据
      let data = comTools.assignObj(this.wapConfig(), {
        mobile: this.$cookies.get("mobile"),
        user_token: this.$cookies.get("userToken"),
        gift_type_id: this.urlObj.id,
        page: this.page
      });
      data.sign = comTools.querySort(data);
      wapApiFun.giftTypeList(data).then(res => {
        if (res.code == 200) {
          console.log("礼包列表", res);
          let resData = res.data;
          this.title = resData.title;
          this.list = this.list.concat(resData.gifts.data);
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.list.length >= resData.gifts.total) {
            this.finished = true;
            console.log("数据全部加载完成");
          }
          this.page++;
        } else {
          this.$toast("网路出错");
        }
      });
    },
    onBack() {
      this.$router.go(-1);
    },
    // 领取礼包
    getCode(id) {
      if (this.$cookies.get("userToken")) {
        let urlObj = comTools.getRequest();
        let data = comTools.assignObj(this.wapConfig(), {
          mobile: this.$cookies.get("mobile"),
          user_token: this.$cookies.get("userToken"),
          gift_id: id
        });
        data.sign = comTools.querySort(data);
        wapApiFun.giftGet(data).then(res => {
          if (res.code == 200) {
            //  res.data.gift_code;
            this.code = res.data.gift_code;
            this.show = true;
          }else {
            this.$toast(res.msg)
          }
        });
      } else {
        this.$router.push({
          name: "login",
          query: { warn: "1001" }
        });
      }
    },
    // 复制礼包码
    copyCode() {
      let that = this;
      this.$copyText(this.code).then(
        function(e) {
          that.$toast("复制成功");
          console.log(e);
          that.show = false;
        },
        function(e) {
          that.$toast("该浏览器不支持自动复制");
          console.log(e);
          that.show = false;
        }
      );
    }
  }
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/com.less";
.moreGift {
  width: 100%;
  .view-bg-color();
  /deep/.van-nav-bar__title {
    font-weight: bold;
  }
  .moreGift-wrapper {
    padding: 0 0.6rem;
    // 礼包区块
    .gift-block {
      background-color: #fff;
      .boxShadow(1px);
      .borderRadius(0.5rem);
      // 游戏
      .game-cont {
        .jc-between();
        padding: 0.5rem 0.3rem;
        .game-icon-des {
          display: flex;

          .i-game {
            width: 2rem;
            img {
              .img();
            }
          }
          .game-des {
            .flex-column();
            margin-left: 0.35rem;
            .game-name-size {
              p {
                &:nth-of-type(1) {
                  font-size: 0.5rem;
                }
                &:nth-of-type(2),
                &:nth-of-type(3) {
                  .font-color();
                  font-size: 0.3rem;
                }
                &:nth-of-type(3) {
                  .theme-color();
                }
              }
            }
            .dis-num {
              display: flex;
              margin-top: 0.1rem;
              span {
                color: #fff;
                background-color: #f00;
                font-size: 0.3rem;
                border-radius: 0.2rem;
                display: inline-block;
                padding: 0.03rem 0.2rem;
                margin-right: 0.2rem;
              }
            }
          }
        }
        .game-down {
          .theme-bg-color();
          border-radius: 0.2rem;
          padding: 0.1rem 0.4rem;
          a {
            color: #fff;
          }
        }
        &:first-child {
          margin-top: 0.5rem;
        }
      }
      // 礼包内容
      .gift-cont {
        width: 100%;
        padding: 0.3rem 0;
        .jc-between();
        .gift-des {
          width: 70%;
          padding-left: 0.3rem;
          p {
            &:nth-of-type(1) {
              font-size: 0.4rem;
            }
            &:nth-of-type(2) {
              font-size: 0.3rem;
              .font-color();
            }
            .ellipsis();
          }
        }
        .get,
        .getted {
          border-radius: 0.2rem;
          padding: 0.1rem 0.4rem;
          .theme-bd-color();
          .theme-color();
          margin-right: 0.3rem;
        }
        .getted {
          .font-color();
          border: 1px solid #888;
          padding: 0.1rem 0.2rem;
        }
      }
    }
  }
  // 弹窗组件
  .dialog {
    .transform(fixed);
    width: 70%;
    background-color: #fff;
    z-index: 10;
    .borderRadius(0.3rem);
    .g-title {
      text-align: center;
      padding-top: 0.3rem;
    }
    .g-code {
      text-align: center;
      padding: 0.3rem;
    }
    .confirm {
      text-align: center;
      padding-bottom: 0.3rem;
      letter-spacing: 0.1rem;
      span {
        .theme-bg-color();
        .borderRadius(0.2rem);
        color: #fff;
        padding: 0.2rem 20%;
        display: inline-block;
      }
    }
  }
}
</style>